import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Container, Button } from '@mui/material';

import { IEmployeeDetails } from "../../../types/employee";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import EmployeeDetailsForm from "../../forms/employeeDetailsForm";
import { Icons } from "../../icons";

const EmployeeAdd = () => {
	const userContext = useUserContext();
	const [formFields, setFormFields] = useState<IEmployeeDetails>({
		adUserName: undefined,
			businessPhone: undefined,
			email: undefined,
			firstName: undefined,
			lastName: undefined,
			personalPhone: undefined,
			title: undefined,
			userGroup: undefined,
			isActive: true,
	});

	const reset = async () => {
		setFormFields({
			adUserName: undefined,
			businessPhone: undefined,
			email: undefined,
			firstName: undefined,
			lastName: undefined,
			personalPhone: undefined,
			title: undefined,
			userGroup: undefined,
			isActive: true,
		});
	}

	return (
		<div className="hwi-customer-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageCustomers}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/employee">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Employee
						</div>
					</section>
					<section className="management-page-form">
						<EmployeeDetailsForm action="add" details={formFields} reloadData={reset} ></EmployeeDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default EmployeeAdd;